export default __webpack_public_path__ + "static/media/13.a6d3db38.jpg";